module.exports = "pegasus/assets/themelp1/small/34.png";